import * as React from "react";

let i = 0;

/**
 * Generate a unique id, with an optional prefix
 * @param prefix
 */
const useGeneratedId = (prefix?: string): string => {
    const [id] = React.useState(() => {
        const result = (prefix ? prefix + "-" : "") + i;
        i++;
        return result;
    });

    return id;
};

export default useGeneratedId;
